<template>
    <admin-layout>
        <section class="p-5 h-full">
            <article class="flex items-center justify-items-center justify-between p-4 bg-primary-50 rounded-lg">
                <article class="flex items-center gap-5">
                    <div class="bg-secondary rounded-lg p-3">
                        <Icon icon="typcn:flow-merge" class="text-3xl text-white m-auto"/>
                    </div>
                    <div>
                        <h1 class="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-gray-800">Answer Bot</h1>
                        <p class="text-sm text-gray-700">Manage and administer your automated response bots</p>
                    </div>
                </article>
                <div>
                  <button
                          @click="onCreateHandle()"
                          type="button" 
                          class="font-medium bg-primary-950 text-white px-5 py-3 text-sm rounded flex items-center gap-1">
                            Saves
                          <Icon icon="stash:new-window-page" class="text-2xl" />
                    </button>
                </div>
            </article>

            <article class="mt-10 bg-white p-5 rounded-lg h-full block">
                <article class="flex h-full gap-5">
                    <div class="w-full" @drop="handleOnDrop" @dragover="handleOnDragOver">
                        <div v-if="isLoading" class="flex items-center justify-center h-full">
                            <h1>Loading</h1>
                        </div>
                        <VueFlow v-else :node-types="nodeTypes">
                            <Background :size="2"  pattern-color="#BDBDBD" />
                            <Controls position="top-left"/>
                        </VueFlow>
                    </div>
                    
                    <Sidebar />
                </article>
            </article>
        </section>
        <pre>{{ nodes }}</pre>
        <pre>{{ edges }}</pre>
    </admin-layout>

</template>

<script setup>
import { markRaw, onMounted } from 'vue';
import { Icon } from "@iconify/vue";
import { VueFlow } from "@vue-flow/core"
import { Background } from '@vue-flow/background'
import { Controls } from '@vue-flow/controls'
import { useBot } from '@/core/composables/useBot'
import { useRoute } from 'vue-router'
import Sidebar from '@/app/components/CustomBotBuilderControl.vue'
import AdminLayout from '@/app/layouts/AdminLayout'
import StartNode from '@/app/components/botBuilder/nodes/StartNode.vue'
import EndNode from '@/app/components/botBuilder/nodes/EndNode.vue'
import SendMessageNode from '@/app/components/botBuilder/nodes/SendMessageNode.vue'
import OptionNode from '@/app/components/botBuilder/nodes/OptionNode.vue'
import ShareLinkNode from '@/app/components/botBuilder/nodes/ShareLinkNode.vue'
import ScriptNode from '@/app/components/botBuilder/nodes/ScriptNode.vue'
import AskForDetailNode from '@/app/components/botBuilder/nodes/AskForDetailNode.vue';
import SetVariableNode from '@/app/components/botBuilder/nodes/SetVariableNode.vue'

const route = useRoute();

const { nodes, edges, isLoading, onCreateHandle, getBotByGuid, handleOnDrop, handleOnDragOver } = useBot()

const nodeTypes = {
  StartNode: markRaw(StartNode),
  EndNode: markRaw(EndNode),
  SendMessageNode: markRaw(SendMessageNode),
  OptionNode: markRaw(OptionNode),
  ShareLinkNode: markRaw(ShareLinkNode),
  ScriptNode: markRaw(ScriptNode),
  AskForDetailNode: markRaw(AskForDetailNode),
  SetVariableNode: markRaw(SetVariableNode),
}

onMounted(async () => {
    await getBotByGuid(route.params.guid)
})
</script>

<style scoped>
@import '@vue-flow/core/dist/style.css';
@import '@vue-flow/core/dist/theme-default.css';
@import '@vue-flow/controls/dist/style.css';
@import '@vue-flow/minimap/dist/style.css';
</style>